var _path, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _circle5, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 50",
    width: 200,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1w",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#818CF8",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#A78BFA",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 35 Q15 15 25 35 Q35 15 45 35",
    stroke: "url(#grad1w)",
    strokeWidth: 4,
    fill: "none",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    width: 4,
    height: 12,
    rx: 1,
    fill: "#818CF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 35,
    width: 4,
    height: 12,
    rx: 1,
    fill: "#8B5CF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35,
    width: 4,
    height: 12,
    rx: 1,
    fill: "#A78BFA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 3,
    fill: "#818CF8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 8,
    r: 2,
    fill: "#6366F1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 13,
    r: 2.5,
    fill: "#A78BFA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 1.5,
    fill: "#C4B5FD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 1.5,
    fill: "#DDD6FE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 36,
    fontFamily: "'Roboto', 'Helvetica', Arial, sans-serif",
    fontSize: 28,
    fontWeight: 700,
    fill: "url(#grad1w)"
  }, "ModelBridge")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.fc8841763b981c4043e81cc53eefe72e.svg";
export { ForwardRef as ReactComponent };